export const slugs = {
  // Main Pages
  home: {
    en: "",
    fa: "",
  },

  signin: {
    en: "sign-in",
    fa: "ورود",
  },

  webApplication: {
    en: "web-application",
    fa: "ساخت-وب-اپلیکیشن",
  },

  mobileApplication: {
    en: "mobile-application",
    fa: "ساخت-اپلیکیشن-موبایل",
  },

  wordpress: {
    en: "wordpress-design",
    fa: "طراحی-وبسایت-وردپرس",
  },

  uiux: {
    en: "ui-ux-design",
    fa: "طراحی-رابط-کاربری",
  },

  social: {
    en: "social-media-management",
    fa: "مدیریت-شبکه-های-اجتماعی",
  },

  seo: {
    en: "seo-digital-marketing",
    fa: "سئو-و-دیجیتال-مارکتینگ",
  },

  portfolio: {
    en: "portfolio",
    fa: "نمونه-کار",
  },

  about: {
    en: "about-us",
    fa: "درباره-ما",
  },

  contact: {
    en: "contact-us",
    fa: "تماس-با-ما",
  },

  // Pricing
  webAppPricing: {
    en: "webapp-pricing",
    fa: "تعرفه-وب-اپلیکیشن",
  },

  mobileAppPricing: {
    en: "mobileapp-pricing",
    fa: "تعرفه-اپلیکیشن-موبایل",
  },

  uiuxPricing: {
    en: "uiux-pricing",
    fa: "تعرفه-طراحی-رابط-کاربری",
  },

  wordpressPricing: {
    en: "wordpress-pricing",
    fa: "تعرفه-وردپرس",
  },

  seoPricing: {
    en: "seo-pricing",
    fa: "تعرفه-سئو",
  },

  // Clients
  dental: {
    en: "dental",
    fa: "کلینیک-دندانپزشکی",
  },

  daycare: {
    en: "daycare",
    fa: "مهدکودک",
  },

  cosmetic: {
    en: "cosmetic",
    fa: "کلینیک-زیبایی",
  },

  gymFitness: {
    en: "gym-fitness",
    fa: "باشگاه-ورزشی",
  },

  restaurantCafe: {
    en: "restaurant-cafe",
    fa: "رستوران-و-کافه",
  }
};